import "../../styles/components/viewingForm.scss";
import { Collapse, Descriptions } from "antd";
import usePdfBlob from "../../hooks/usePdfBlob";
import PdfPreviewer from "../PdfPreviewer";

const { Panel } = Collapse;

function ViewingForm({ viewingDataConfig, data, viewingType }) {
  const descData = viewingDataConfig?.map((section) => {
    const updatedCollapseItems = section?.collapseItems?.map((item) => {
      const rawValue = data[item?.name] ?? null;
      const children = item?.render ? item.render(rawValue) : rawValue;

      return {
        ...item,
        children,
      };
    });

    return {
      ...section,
      collapseItems: updatedCollapseItems,
    };
  });

  const { pdfBlobUrl, loading } = usePdfBlob({
    endpoint: "/fsr/pdf/live",
    params: {
      employee_id: data.employee_id,
      academic_term: data.academic_term,
      position_id: data.position_id,
      status_of_appointment: data.status_of_appointment,
    },
    enabled: viewingType === "pdf",
  });

  if (viewingType === "pdf") {
    return (
      <PdfPreviewer pdfBlobUrl={pdfBlobUrl} loading={loading} height="60vh" />
    );
  }

  return (
    <>
      {descData?.map((collapseItems) => {
        return (
          <>
            <div className="viewform">
              {/* NOTE: MAKE THE KEY TO 1 IN SENDING THE PROPS IF YOU WANT IT ACTIVE, 0 OTHERWISE */}
              <Collapse defaultActiveKey={[1]} bordered={false}>
                <Panel
                  header={collapseItems?.collapseName}
                  key={collapseItems?.key}
                >
                  <Descriptions
                    size={"small"}
                    bordered={true}
                    column={1}
                    items={collapseItems?.collapseItems}
                  />
                </Panel>
              </Collapse>
            </div>
          </>
        );
      })}
    </>
  );
}

export default ViewingForm;
